module.exports = {
  "cancel": "Cancel",
  "other": "Other",
  "error": {
    "deleted": {
      "fav": "Favorites have been deleted"
    },
    "badrequest": "Param error",
    "forbidden": "Forbidden Access",
    "unknown": "Server unknown error",
    "frequency": {
      "limit": "The operation is too frequent"
    },
    "already": {
      "group": "Group already exists"
    },
    "notfound": {
      "fav": "Not Found Fav"
    }
  },
  "del": "Delete",
  "comfirmToDel": "Comfirm Delete",
  "title": "My Collection",
  "Within7days": "Within 7 days",
  "search": "Search",
  "from": "From",
  "all": "All",
  "sure": "confirm",
  "noSearchData": "No search results",
  "loadError": "Load Fail",
  "forward": "Share",
  "photo": "Pic/Video",
  "IAnd": "My chat with",
  "notSuportView": "Not Suport View This Type",
  "whoCollect": "‘s Collection",
  "shareFail": "Share Fail",
  "charRecord": "Missing Translation",
  "emptyTxt": "There is nothing",
  "previewImgFail": "Preview Img Fail",
  "doc": "Doc",
  "isdelete": "Confirm to delete?",
  "ltnr": "Chat"
}